import { useState } from 'react';

const useOverviewFilters = () => {
  const [selectedFilter, setSelectedFilter] = useState('org_email');
  const [searchTerm, setSearchTerm] = useState('');

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  return {
    searchTerm,
    selectedFilter,
    handleFilterChange,
    handleSearchChange,
  };
};

export default useOverviewFilters;
